import CUSTOMER_LOGOS from '../../auth/common/marketing/customer-logos';

import styles from './MarketingTrustedBy.module.less';

/** The "Trusted by" customer logo grid shown under the marketing blurb. */
const MarketingTrustedBy = () => (
  <div>
    <div className={styles.label}>Trusted by</div>
    <ul className={styles.logos}>
      {Object.entries(CUSTOMER_LOGOS).map(([key, Logo]) => (
        <li className={styles.item} key={key}>
          <Logo />
        </li>
      ))}
    </ul>
  </div>
);

export default MarketingTrustedBy;
